/**
 * IngestPage.tsx — Ingest / Workspace surface orchestrator (B2-step-3).
 * Holds the view state (dashboard | upload). The upload flow creates a real
 * project, uploads its documents, auto-starts the analysis and stays on the
 * UploadView as a live progress surface; "back" returns to the dashboard while
 * the server-side run continues (the app-wide watcher announces completion).
 */
import { useState } from "react";

import { Dashboard } from "./Dashboard";
import { UploadView } from "./UploadView";

type View = "dashboard" | "upload";

export function IngestPage(): JSX.Element {
  const [view, setView] = useState<View>("dashboard");

  if (view === "upload") {
    return <UploadView onBack={() => setView("dashboard")} />;
  }
  return <Dashboard onNew={() => setView("upload")} />;
}
